import {Button, Container, HStack} from '@chakra-ui/react'
import Link from 'next/link'
import {Model, ServiceGroup, SkillDescription} from '../../dataModels/Service'
import useTranslation from 'next-translate/useTranslation'
import {useRouter} from 'next/router'
import {useTheme} from '@emotion/react'
import {useIsMobile} from '../../hooks/useIsMobile'
import {track} from '../../utils/eventTracking/track'
import {useEffect} from 'react'

interface Props {
  serviceGroup: ServiceGroup
}

const RenderButtonItems = ({serviceGroup}: Props) => {
  const router = useRouter()
  const {t} = useTranslation()
  const isMobile = useIsMobile()

  useEffect(() => {
    if (serviceGroup.services.length === 1) {
      router.push(serviceGroup.services[0].href)
    }
  }, [])

  return (
    <>
      {serviceGroup.services.map(service => {
        return (
          <Link href={service.href} key={service.href} replace>
            <Button
              onClick={() => {
                track(
                  `feature-click-${
                    service instanceof SkillDescription
                      ? service.skillName
                      : (service as Model).modelName
                  }-button`
                )
              }}
              _notLast={{mr: isMobile ? 0 : 4}}
              w='auto'
              variant={service.href != router.pathname ? 'dark' : 'primary'}
              borderRadius='full'>
              {t(`${service.title}`)}
            </Button>
          </Link>
        )
      })}
    </>
  )
}

const ServiceGroupButtons = ({serviceGroup}: Props) => {
  const theme = useTheme()
  const isMobile = useIsMobile()

  return (
    <HStack w='100vW'>
      {/* @ts-ignore size is not found for some reason*/}
      <Container maxW={theme.sizes.container} p={0}>
        {isMobile ? (
          <HStack overflowY='auto' className='hide-scrollbar' spacing={4} px={4}>
            <RenderButtonItems serviceGroup={serviceGroup} />
          </HStack>
        ) : (
          <RenderButtonItems serviceGroup={serviceGroup} />
        )}
      </Container>
    </HStack>
  )
}
export default ServiceGroupButtons
